import { Stack } from "@mui/material";
import { Modal } from "antd";
import {useRef, useState } from "react";
import AntdModal from "../Modal/AntdModal.component";

import {
  IFileData,
  NotificationModalBody,
} from "./NotificationModal.component";
import "./Notification.styles.css";

type NotificationDivStyleProps = {
  header: string;
  description: string;
  notificationId: string;           

  files: any;
  
  getModalIsOpen?: (isModal: boolean) => void;
  getModalIsclose?: (isModal: boolean) => void;
}
const FlashNotificationDivStyle = ({
  header,
  description,
  notificationId,    
  files,
  getModalIsOpen,
}: NotificationDivStyleProps) => {

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
    getModalIsOpen?.(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    getModalIsOpen?.(false);
  };

  return (
    <>
      <Stack
        onClick={showModal}
        direction={"column"}
        rowGap={1}
        className="flash-notify-div-container"
      >
        <h5>{header}</h5>
      </Stack>

      <AntdModal
        centered={true}
        isModalOpen={isModalOpen}
        keyboard={false}
        width={600}
        closable={false}
        closeIcon={false}
        maskClosable={false}
        modalBody={
          <NotificationModalBody
            header={header}
             notificationId={notificationId}
            description={description}
            actions={{
              close: handleCancel,
            }}
            files={files}
          />
        }
      />
    </>
  );
};

export default FlashNotificationDivStyle;
